import { getOwner, setOwner } from '@ember/application';
import { assert } from '@ember/debug';
import EmberObject from '@ember/object';
import dispatcher from 'mewe/dispatcher';
import config from 'mewe/config/environment';
import { ActionHandler } from '@ember/-internals/runtime';

export default EmberObject.extend(ActionHandler, {
  init() {
    if (config.environment !== 'test') {
      assert('Missing ctx in action-controller', this.ctx);

      let owner = getOwner(this.ctx);

      assert('Missing owner in action-controller', owner);

      setOwner(this, owner);
    }

    this._super(...arguments);
  },

  dispatch: dispatcher.dispatch,
});
